<template>
  <div class="landing-page" id="home">
    <h1 class="landing-page-title extra-large-text-list text-center">
      Build What's <span class="special-text"> Next.</span>
    </h1>

    <nuxt-link
      to="/#contact"
      aria-label="Navigate to contact form"
      class="landing-page-video-button heading-5-list-bold"
      >Start now.</nuxt-link
    >

    <div class="landing-page-video">
      <video
        ref="video"
        autoplay
        loop
        muted
        playsinline
        poster="https://cdn.vortec.io/website/landing_animation_vortec_poster.webp">
        <source src="https://cdn.vortec.io/website/landing_animation_vortec.mp4" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script lang="ts" setup>
// The animated gradient border on the "Start now." button is now pure CSS
// (see scss/components/_landingPage.scss) — no per-frame JS, and it only runs
// on hover and respects prefers-reduced-motion.
</script>
